import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { PartnerApi } from "../../../../../../../../../services/Api/Partner/partnerTypes";

interface Props {
	partner: PartnerApi;
}

const PartnerInfoCard = ({ partner }: Props) => {
	const { t } = useTranslation("admin");

	return (
		<Card>
			<Card.Body>
				<h5>{t("lib:common.word.informations")}</h5>
				{partner.keeper && (
					<div className={"card-body-item"}>
						<div className={"item-info"}>
							<span className={"label"}>{t("modules.partner.field.keeper.title")}</span>
							<span>{partner.keeper}</span>
						</div>
					</div>
				)}
				{partner.keeper && (
					<div className={"card-body-item"}>
						<div className={"item-info"}>
							<span className={"label"}>Slug</span>
							<span>{partner.slug}</span>
						</div>
					</div>
				)}
			</Card.Body>
		</Card>
	);
};
export default PartnerInfoCard;
